/* eslint-disable no-undef */
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useQuery } from "react-query";
import * as FileSaver from "file-saver";
import { Button } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DownloadIcon } from "@components/icons";
import { fetchDownloadSensorData, fetchDownloadTreeData } from "../services/sensorCrud";

const usefetchCheckState = ({ parameters }) => {
  const checkedParameters = parameters.filter((parameter) => parameter.checked);
  const checkedNames = checkedParameters.map((parameter) => parameter.name);
  const parameterQuery = checkedNames.join(",");
  return { parameterQuery: parameterQuery, checkedNames: checkedNames };
};

export const ExportData = ({ tree, sensors, fileName, setSuccessMessage, parameters }) => {
  const [plotData, setPlotData] = useState([]);
  const [getData, setGetData] = useState(false);
  const { parameterQuery, checkedNames } = usefetchCheckState({ parameters });
  //fetch the sensor data from api once the button is clicked
  const sensor_ids = sensors.map((sensor) => sensor.id);
  const { isLoading, isRefetching } = useQuery(
    parameterQuery,
    () =>
      tree
        ? fetchDownloadTreeData({ tree, sensors, parameterQuery })
        : fetchDownloadSensorData({ sensors: sensor_ids, parameterQuery }),
    {
      refetchOnWindowFocus: false,
      enabled: !!getData,
      onSuccess: (res) => {
        let { data, mean } = res;
        tree ? (data = data[tree.id]) : [];
        tree ? (mean = mean[tree.id]) : [];
        sensors.map((sensor) => {
          const key = sensor.id;
          const newData = { name: sensor.name, data: [] };
          if (data[key] !== undefined) {
            data[key].time.map((tim, index) => {
              let dataObj = {
                time: tim,
              };
              checkedNames.forEach((parameter) => {
                if (data[key][parameter] !== undefined) {
                  dataObj[parameter] = data[key][parameter][index];
                }
              });
              dataObj["time_mean"] = mean[key].time[index];
              checkedNames.forEach((parameter) => {
                if (mean[key][parameter] !== undefined) {
                  dataObj[parameter + "_mean"] = mean[key][parameter][index];
                }
              });
              newData.data.push(dataObj);
            });
            setPlotData((prev) => [...prev, newData]);
          }
        });
        setSuccessMessage("File has been downloaded successfully!");
        setGetData(false);
      },
    }
  );

  fileName = fileName ? fileName : "Unknown";
  const { t } = useTranslation();

  //ready to export data once we do have data inside plotDataState
  useEffect(() => {
    if (plotData.length > 0) {
      if (!isLoading) {
        exportToExcel({ plotData, fileName, setPlotData });
      }
    }
  }, [plotData]);

  return (
    <div className="d-flex align-items-center gap-2">
      <Button variant="outline-primary d-flex align-items-center" onClick={() => setGetData(true)}>
        <>
          <DownloadIcon />
          {t("download")} &nbsp;
          {(isLoading || isRefetching) && <Spinner animation="border" size="sm" />}
        </>
      </Button>
    </div>
  );
};

const exportToExcel = ({ plotData, fileName, setPlotData }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  var wb = XLSX.utils.book_new();
  plotData?.map((data) => {
    var wsPersonDetails = XLSX.utils.json_to_sheet(data.data);
    XLSX.utils.book_append_sheet(wb, wsPersonDetails, `${data.name}`);
  });
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  // // eslint-disable-next-line no-undef, no-undef
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
  setPlotData([]);
};
